const services = [
  {
    id: 1,
    icon: "flaticon-responsive",
    title: "Website\nDevelopment",
    text: "Captivating websites, driving business success, are our specialty.",
  },
  {
    id: 2,
    icon: "flaticon-computer",
    title: "Graphic\nDesigning",
    text: "Graphic design expertise, elevating brands with creative strategy.",
  },

  {
    id: 3,
    icon: "flaticon-ui",
    title: "Ui/UX\ndesigning",
    text: "Intuitive interfaces for enhanced user experiences.",
  },
  {
    id: 4,
    icon: "flaticon-development",
    title: "Seo & Content\nWriting",
    text: "Boosting visibility and connecting with audiences.",
  },
  {
    id: 5,
    icon: "flaticon-app-development",
    title: "App\nDevelopment",
    text: "Create user-friendly experiences that engage and satisfy.",
  },
  {
    id: 6,
    icon: "flaticon-research",
    href: "/research-development",
    title: "Creative Asset\nDesign",
    text: "Design high-quality assets tailored for web and app development",
  },
  {
    id: 7,
    icon: "flaticon-responsive",
    title: "Wix\nDevelopment",
    text: "Beautiful Wix websites crafted for performance, flexibility, and growth.",
  },
];

const tech = [
  {
    title: "Python",
    icon: "https://img.icons8.com/color/128/000000/python.png",
  },
  {
    title: "HTML",
    icon: "https://img.icons8.com/color/128/000000/html-5.png",
  },
  {
    title: "CSS",
    icon: "https://img.icons8.com/color/128/000000/css3.png",
  },
  {
    title: "Bootstrap",
    icon: "https://img.icons8.com/color/128/000000/bootstrap.png",
  },
  {
    title: "Tailwind CSS",
    icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDML5CFq70Y9FJ52YnyCjfdyUA3g9B6is_jA&s",
  },
  {
    title: "JavaScript",
    icon: "https://img.icons8.com/color/128/000000/javascript.png",
  },
  {
    title: "React.js",
    icon: "https://img.icons8.com/color/128/000000/react-native.png",
  },
  {
    title: "Next.js",
    icon: "https://img.icons8.com/color/128/000000/nextjs.png",
  },
  {
    title: "Node.js",
    icon: "https://img.icons8.com/color/128/000000/nodejs.png",
  },
  {
    title: "PHP",
    icon: "https://img.icons8.com/color/128/000000/php.png",
  },
  {
    title: "Laravel",
    icon: "https://static-00.iconduck.com/assets.00/laravel-icon-497x512-uwybstke.png",
  },
  {
    title: "React Native",
    icon: "https://img.icons8.com/color/128/000000/react-native.png",
  },
  {
    title: "Flutter",
    icon: "https://img.icons8.com/color/128/000000/flutter.png",
  },
  {
    title: "Firebase",
    icon: "https://img.icons8.com/color/128/000000/firebase.png",
  },

  {
    title: "WordPress",
    icon: "https://img.icons8.com/color/128/000000/wordpress.png",
  },
  {
    title: "Wix",
    icon: "https://img.icons8.com/color/128/000000/wix.png",
  },
  {
    title: "Shopify",
    icon: "https://img.icons8.com/color/128/000000/shopify.png",
  },
  {
    title: "MySQL",
    icon: "https://img.icons8.com/color/128/000000/mysql.png",
  },
  {
    title: "API Integration",
    icon: "https://img.icons8.com/color/128/000000/api.png",
  },
];



export const servicesTechStack = {
  title: "Tech Stack",
  tech,
};

const servicesSection = {
  title: "LET’S CREATE SOMETHING\ntogether",
  text: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised.",
  services,
};

export const servicesSectionThree = {
  title: "What we’re offering",
  services,
};



export default servicesSection;

export const serviceSectionThree = [
  {
    id: 1,
    icon: "flaticon-responsive",
    href: "/web-development",
    title: "Website\nDevelopment",
  },
  {
    id: 2,
    icon: "flaticon-computer",
    href: "/graphic-designing",
    title: "graphic\ndesigning",
  },
  {
    id: 3,
    icon: "flaticon-app-development",
    href: "/app-development",
    title: "App\nDevelopment",
  },
  {
    id: 4,
    icon: "flaticon-ui",
    href: "/ui-designing",
    title: "Ui/UX\ndesigning",
  },
  {
    id: 5,
    icon: "flaticon-development",
    href: "/seo",
    title: "seo & content\nwriting",
  },
  {
    id: 6,
    icon: "flaticon-research",
    href: "/research-development",
    title: "Creative Asset\nDesign",
  },
  {
    id: 7,
    icon: "flaticon-responsive",
    href: "/wix-development",
    title: "Wix\nDevelopment",
  },
];

export const servicesSectionOne = {
  title: "BUILDING BETTER\nFUTURES",
  text: "Where Excellence in Service and Comprehensive Training Come Together to Shape Perfect Solutions.",
  services: serviceSectionThree,
};

export const serviceSix = {
  tagline: "Checkout Our Services",
  title: "What we’re offering",
  services: [
    {
      id: 1,
      image: "service-1-1.jpg",
      title: "Business Growth",
      href: "/digital-marketing",
      icon: "flaticon-mobile-analytics",
      text: "Aliq is notm hendr erit a augue insu image pellen simply freed text ipsum.",
    },
    {
      id: 2,
      image: "service-1-2.jpg",
      title: "Marketing Advice",
      href: "/digital-marketing",
      icon: "flaticon-research",
      text: "Aliq is notm hendr erit a augue insu image pellen simply freed text ipsum.",
    },
    {
      id: 3,
      image: "service-1-3.jpg",
      title: "Finance Consulting",
      href: "/digital-marketing",
      icon: "flaticon-creative",
      text: "Aliq is notm hendr erit a augue insu image pellen simply freed text ipsum.",
    },
  ],
};

export const serviceSeven = [
  {
    id: 1,
    icon: "flaticon-laptop",
    href: "/digital-marketing",
    title: "Speed Optimization",
    text: "Lorem ipsum is are many variations of pass of majority.",
  },
  {
    id: 2,
    icon: "flaticon-presentation",
    href: "/digital-marketing",
    title: "Marketing Analysis",
    text: "Lorem ipsum is are many variations of pass of majority.",
  },
  {
    id: 3,
    icon: "flaticon-target",
    href: "/digital-marketing",
    title: "SEO and Backlinks",
    text: "Lorem ipsum is are many variations of pass of majority.",
  },
  {
    id: 4,
    icon: "flaticon-visualization",
    href: "/digital-marketing",
    title: "Content Marketing",
    text: "Lorem ipsum is are many variations of pass of majority.",
  },
];

export const serviceEight = {
  text: "Our Services List",
  title: "What We’re Offering",
  services: [
    {
      id: 1,
      title: "Consumer Products",
      href: "/digital-marketing",
      icon: "flaticon-vector-4",
    },
    {
      id: 2,
      title: "Audit Marketing",
      href: "/digital-marketing",
      icon: "flaticon-analysis",
    },
    {
      id: 3,
      title: "Advice Bankings",
      href: "/digital-marketing",
      icon: "flaticon-business",
    },
    {
      id: 4,
      title: "Marketing Rules",
      href: "/digital-marketing",
      icon: "flaticon-global",
    },
  ],
};

export const serviceNine = [
  {
    id: 1,
    image: "service-9-1.jpg",
    icon: "flaticon-responsive",
    title: "GRAPHIC DESIGNING",
    text: "Lorem ipsum is simply free sed qui magni dolores eos qui voptam.",
    href: "/ui-designing",
  },
  {
    id: 2,
    image: "service-9-2.jpg",
    icon: "flaticon-computer",
    title: "graphic designing",
    text: "Lorem ipsum is simply free sed qui magni dolores eos qui voptam.",
    href: "/graphic-designing",
  },
  {
    id: 3,
    image: "service-9-3.jpg",
    icon: "flaticon-global",
    title: "digital marketing",
    text: "Lorem ipsum is simply free sed qui magni dolores eos qui voptam.",
    href: "/digital-marketing",
  },
  {
    id: 4,
    image: "service-9-4.jpg",
    icon: "flaticon-development",
    title: "Content Writting",
    text: "Lorem ipsum is simply free sed qui magni dolores eos qui voptam.",
    href: "/seo",
  },
  {
    id: 5,
    image: "service-9-5.jpg",
    icon: "flaticon-app-development",
    title: "App Development",
    text: "Lorem ipsum is simply free sed qui magni dolores eos qui voptam.",
    href: "/app-development",
  },
  {
    id: 6,
    image: "service-9-6.jpg",
    icon: "flaticon-planning",
    title: "ui / ux designing",
    text: "Lorem ipsum is simply free sed qui magni dolores eos qui voptam.",
    href: "/ui-designing",
  },
];
